import { EventEmitter, Injectable, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FirebaseApp, initializeApp } from 'firebase/app';
import { Database, getDatabase, onValue, ref, serverTimestamp, set, remove, get, onChildAdded } from 'firebase/database';
import { getAuth } from 'firebase/auth';
import { CustomNotification } from '../_models/notification';
import { TokenService } from './token.service';
import { v4 as uuidv4 } from 'uuid';
import { FirebaseAuthService } from './firebase-auth.service';
import { firebaseConfig } from '../../environments/firebase-config';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private app: FirebaseApp;
  private auth: any;
  private db: Database;
  private notifications: any[] = [];

  @Output()
  private fire: EventEmitter<CustomNotification> = new EventEmitter();

  @Output()
  notificationsObservable = new EventEmitter<CustomNotification[]>();

  constructor(
    private tokenService: TokenService,
    private firebaseAuthService: FirebaseAuthService
  ) {
      this.app = initializeApp(firebaseConfig);
      this.db = getDatabase(this.app);
  }

  public init() {
    const userId = this.firebaseAuthService.getUserId();

    if (!userId) {
      console.log('Usuário não autenticado');
      return;
    }

    this.loadAllNotifications();
    this.listenForNewNotifications();
  }

  private loadAllNotifications(): void {
    const userId = this.tokenService.id.toLowerCase();
    const notificationsRef = ref(this.db, `notification/${userId}`);

    get(notificationsRef).then((snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        this.notifications = Object.values(data).sort((a: any, b: any) =>
          new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()
        );
  
        this.notificationsObservable.emit(this.notifications);
      }
    });
  }
  
  private listenForNewNotifications(): void {
    const userId = this.tokenService.id.toLowerCase();
    const notificationsRef = ref(this.db, `notification/${userId}`);
  
    onChildAdded(notificationsRef, (snapshot) => {
      const newNotification: CustomNotification = snapshot.val();
  
      if (!this.notifications.find(n => n.id === newNotification.id)) {
        this.notifications.push(newNotification);
        this.notificationsObservable.emit(this.notifications);
        this.fire.emit(newNotification);
      }
    });
  }  

  delete(not: CustomNotification): void {
      const userId = this.tokenService.id.toLowerCase();
      const notRef = ref(this.db, `notification/${userId}/${not.id}`);

      remove(notRef).then(() => {
          this.notifications = this.notifications.filter(n => n.id !== not.id);
          this.notificationsObservable.emit(this.notifications);
      });
  }

  addNotification(): void {
    if (!this.firebaseAuthService.getUserId()) return;
    const userId = this.tokenService.id.toLowerCase();
  
    const not: CustomNotification = {
      id: uuidv4(),
      idUser: userId,
      nameUser: 'Teste',
      code: 'chat_rota',
      title: '',
      message: '',
      idReference: userId,
      timestamp: serverTimestamp() as any,
    };
  
    const notRef = ref(this.db, `notification/${userId}/${not.id}`);
    set(notRef, not);
  }  

  getNotificationAdded(): EventEmitter<CustomNotification> {
      return this.fire;
  }

  getNotifications(): EventEmitter<CustomNotification[]> {
      return this.notificationsObservable;
  }
}
